export const initialStateEditPlan = { data: [] };
